export const PRODUCT_ADVANCED_PARAMS = ['color', 'size', 'minPrice', 'maxPrice', 'minStock', 'maxStock', 'createdFrom', 'createdTo'] as const;
export const PRODUCT_FILTER_PARAMS = ['q', 'type', 'brand', 'supplier', 'approval', ...PRODUCT_ADVANCED_PARAMS] as const;

export function clearProductFilters(params: URLSearchParams, scope: 'advanced' | 'all'): URLSearchParams {
  const next = new URLSearchParams(params);
  for (const key of scope === 'advanced' ? PRODUCT_ADVANCED_PARAMS : PRODUCT_FILTER_PARAMS) next.delete(key);
  next.delete('page');
  return next;
}
